import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Product from "./pages/Product";
import Contact from "./pages/Contact";
import AmazonIntegration from "./pages/AmazonIntegration";
import AmazonDataProtectionPolicy from "./pages/AmazonDataProtectionPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import InformationSecurityPolicy from "./pages/InformationSecurityPolicy";
import DataClassificationPolicy from "./pages/DataClassificationPolicy";
import IncidentResponsePolicy from "./pages/IncidentResponsePolicy";
import DataRetentionPolicy from "./pages/DataRetentionPolicy";
import TermsConditions from "./pages/TermsConditions";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Toaster position="top-right" richColors />
      {/*  <BrowserRouter >*/}
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/product" element={<Product />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/amazon-integration" element={<AmazonIntegration />} />
            <Route path="/amazon-data-protection-policy" element={<AmazonDataProtectionPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/information-security-policy" element={<InformationSecurityPolicy />} />
            <Route path="/data-classification-policy" element={<DataClassificationPolicy />} />
            <Route path="/incident-response-policy" element={<IncidentResponsePolicy />} />
            <Route path="/data-retention-policy" element={<DataRetentionPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
